import { Label } from "@/components/atoms/texts/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/molecules/popover";
import { Button } from "@/components/molecules/buttons/button";
import { useEffect, useRef, useState } from "react";
import Polygon1 from "@/assets/Polygon1.svg"
import ControlsDownload from "@/components/molecules/controlsDownload";
import Chip from "@/components/molecules/buttons/Chip";
// import ReadingStatus from "@/components/atoms/ReadingStatus";
import getCurrencySymbolFromCode from "@/utils/getCurrencySymbolFromCode";
import { useTranslation } from "react-i18next";
import getMonthName from "@/utils/getMonthName";
import ReadingStatus from "./readingStatus";
import { useDeletePayslip } from "@/services/admin-services/mutations/useDeletePayslip";
import { useGetPayslip } from "@/services/consultant-services/api-rest/useGetPayslip";
import { useGetConsultantPayslip } from "@/services/admin-services/api-rest/useGetConsultantPayslip";
import { useToast } from "@/components/organisms/feedback/use-toast";
import { useAuthContext } from '@/context/AuthContext';
import EditAdminModal from "@/components/macro-organisms/EditAdminModal";
import NewPayslipPanel from "@/components/macro-organisms/panels/panels-admin/NewPayslip/NewPayslipPanel";
import FormNewPayslip from "@/components/macro-organisms/panels/panels-admin/NewPayslip/FormNewPayslip";
import { useUpdatePayslip } from "@/services/admin-services/mutations/useUpdatePayslip";
import { useStorePayslip } from '@/services/admin-services/api-rest/useStorePayslip';
import { useUpdateConsultantProfile } from "@/services/mutation/admin-mutations/useUpdateConsultantProfile";
import useAllConsultantProfiles from "@/services/admin-services/query/useAllConsultantProfiles";
import { useParams } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Payslip({ data, dataOwner = false, currentConsultantProfileUuid, showAllInformations, forMassiveInput, refetchFromScratch = () => { }, editable = false, minimized = false, setPayslip, removePayslip, verticalView = false, hideControls = false }) {

    const symbol = getCurrencySymbolFromCode(data?.currency)
    const [t] = useTranslation("global");
    const { toast } = useToast();

    // import hook for actions ---------------------------------
    const { deletePayslip, loading: loadingDelete, error: errorDelete, data: dataDelete } = useDeletePayslip();
    let getPayslip, loadingFile, errorFile, payslipFile;

    if (dataOwner) {
        const consultantPayslipHook = useGetConsultantPayslip();
        if (consultantPayslipHook) {
            getPayslip = consultantPayslipHook.getPayslip;
            loadingFile = consultantPayslipHook.loading;
            errorFile = consultantPayslipHook.error;
            payslipFile = consultantPayslipHook.data;
        }
    } else {
        const payslipHook = useGetPayslip();
        if (payslipHook) {
            getPayslip = payslipHook.getPayslip;
            loadingFile = payslipHook.loading;
            errorFile = payslipHook.error;
            payslipFile = payslipHook.data;
        }
    }
    const { updatePayslip, loading: loadingUpdate, error: errorUpdate, data: dataUpdate } = useUpdatePayslip();
    const { storePayslip, loading: storeLoading, error: storeError, data: storeData } = useStorePayslip();
    const [submissionError, setSubmissionError] = useState(false);
    const [submissionSuccess, setSubmissionSuccess] = useState(false);
    const [dataToSend, setDataToSend] = useState(null);
    const submitRef = useRef(null);

    const { hasPrivileges } = useAuthContext();
    const isAdmin = hasPrivileges('ADMIN_PAYSLIP');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    // Edition du profil consultant ----------------------------
    const { id: consultantUuid } = useParams();
    const { consultantProfiles, loading: profilesLoading, error: profilesError } = useAllConsultantProfiles({ skip: !isAdmin });
    const { setConsultantProfile, loading: loadingProfile, error: errorProfile } = useUpdateConsultantProfile();
    const [isEditingProfile, setIsEditingProfile] = useState(false);
    const [selectedProfileUuid, setSelectedProfileUuid] = useState(data?.consultantProfileUuid || "");
    const currentProfileName = consultantProfiles?.find(p => p.uuid === (selectedProfileUuid || data?.consultantProfileUuid))?.name || data?.consultantProfileUuid || "--";
    const shouldDisplayPayslipProfile =
        isAdmin &&
        Boolean(data?.consultantProfileUuid) &&
        Boolean(currentConsultantProfileUuid) &&
        data.consultantProfileUuid !== currentConsultantProfileUuid;

    // const handleSaveProfile = async () => {
    //     if (!consultantUuid || !selectedProfileUuid) return;
    //     try {
    //         const result = await setConsultantProfile(consultantUuid, selectedProfileUuid);
    //         if (result?.data) {
    //             setIsEditingProfile(false);
    //             refetchFromScratch();
    //         }
    //     } catch (err) {
    //         console.error("Erreur lors de la mise à jour du profil consultant:", err);
    //     }
    // };


    // old payslip ? -------------------------------------------
    const providedDate = new Date(data?.createdAt);
    const currentDate = new Date();
    const differenceInTime = currentDate.getTime() - providedDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    // Extraction du mois et de l'année depuis data?.period si nécessaire
    // const periodDate = data?.period ? new Date(data?.period) : null;
    // const month = data?.month || (periodDate ? periodDate.getMonth() + 1 : null); // Mois issu de period (0-indexé, donc +1)
    // const year = data?.year || (periodDate ? periodDate.getFullYear() : null);
    const month = data?.month
    const year = data?.year
    // handle functions ----------------------------------------
    const handleGetPayslipFile = () => {
        if (data?.payslipFileUuid) {
            getPayslip(data?.payslipFileUuid);
        }
    };
    const handleOpenPayslipFile = () => {
        if (!payslipFile) {
            handleGetPayslipFile();
        }
        payslipFile && window.open(payslipFile?.url, "_blank")// Ouvrir l'URL dans un nouvel onglet
    }
    useEffect(() => {
        payslipFile && window.open(payslipFile?.url, "_blank")// Ouvrir l'URL dans un nouvel onglet
    }, [payslipFile]);


    const handleDelete = async () => {
        if (removePayslip) {
            console.log("removePayslip", data);
            removePayslip(data);
        } else {
            try {
                await deletePayslip({ variables: { uuid: data?.uuid } });
            } catch (e) {
                console.error("Error deleting handleDelete:", e);
            }
        }
    };

    const handleSubmitUpdate = async (formData) => {
        setDataToSend(formData);
        console.log("handleSubmitUpdate formData =", formData, setPayslip);
        if (setPayslip) {
            setPayslip(formData);
            setIsEditModalOpen(false);
        } else {
            try {
                setSubmissionError(null);
                setSubmissionSuccess(false);
                if (formData.file) {
                    const fileResponse = await formData.file && storePayslip(formData.file, formData?.consultantUuid);
                } else {
                    sendUpdatePayslip(null, formData);
                }
            } catch (err) {
                setSubmissionError(err.message);
                console.error("Erreur lors de la soumission:", err);
            }
        }
    };
    const sendUpdatePayslip = async (uuidFile, formData) => {
        console.log("sendUpdatePayslip uuidFile =", uuidFile, formData);
        const updatedPayslip = uuidFile ? {
            payslipFileUuid: uuidFile || formData?.payslipFileUuid || dataToSend?.payslipFileUuid,
            period: formData ? formData?.period : dataToSend?.period,
            currency: formData ? formData?.currency : dataToSend?.currency,
            grossSalary: parseFloat(formData ? formData?.grossSalary : dataToSend?.grossSalary),
            netSalary: parseFloat(formData ? formData?.netSalary : dataToSend?.netSalary),
            taxes: parseFloat(formData ? formData?.taxes : dataToSend?.taxes),
            employerContributions: parseFloat(formData ? formData?.employerContributions : dataToSend?.employerContributions),
            employeeContributions: parseFloat(formData ? formData?.employeeContributions : dataToSend?.employeeContributions),
            comment: formData ? formData?.comment : dataToSend?.comment,
            bonus: formData ? formData?.bonus : dataToSend?.bonus,
            paymentDate: formData ? formData?.paymentDate : (dataToSend?.paymentDate || undefined),
            uuid: formData ? formData?.uuid : dataToSend?.uuid,
            // consultantProfileUuid reçu tel quel, non modifié
            consultantProfileUuid: formData ? formData?.consultantProfileUuid : dataToSend?.consultantProfileUuid,
        } : {
            period: formData ? formData?.period : dataToSend?.period,
            currency: formData ? formData?.currency : dataToSend?.currency,
            grossSalary: parseFloat(formData ? formData?.grossSalary : dataToSend?.grossSalary),
            netSalary: parseFloat(formData ? formData?.netSalary : dataToSend?.netSalary),
            taxes: parseFloat(formData ? formData?.taxes : dataToSend?.taxes),
            employerContributions: parseFloat(formData ? formData?.employerContributions : dataToSend?.employerContributions),
            employeeContributions: parseFloat(formData ? formData?.employeeContributions : dataToSend?.employeeContributions),
            comment: formData ? formData?.comment : dataToSend?.comment,
            bonus: formData ? formData?.bonus : dataToSend?.bonus,
            paymentDate: formData ? formData?.paymentDate : (dataToSend?.paymentDate || undefined),
            uuid: formData ? formData?.uuid : dataToSend?.uuid,
            // consultantProfileUuid reçu tel quel, non modifié
            consultantProfileUuid: formData ? formData?.consultantProfileUuid : dataToSend?.consultantProfileUuid,
        };

        await updatePayslip({
            variables: { updatedPayslip },
        });
    };
    useEffect(() => {


        if (storeData) {
            dataToSend && sendUpdatePayslip(storeData.uuid);
        }

        storeError && setSubmissionError(storeError);
    }, [storeError, storeData]);

    useEffect(() => {
        if (dataUpdate?.updatePayslip?.uuid) {
            setSubmissionSuccess(true);
            refetchFromScratch();
        }
        errorUpdate && setSubmissionError(errorUpdate);
    }, [errorUpdate, dataUpdate]);

    // TODO : texte à mettre dans global
    useEffect(() => {
        if (dataDelete) {
            toast({
                variant: "success",
                title: "success.backendOperation.delete",
                duration: 8000,
                description: "La fiche de paie " + data?.month + "/" + data?.year + " " + data?.comment + " a été supprimée"
            })
            refetchFromScratch(1)
        } else if (dataDelete?.deleteCompanyBenefitInvoice == false && errorDelete) {
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 8000,
                description: errorDelete?.message
            })
        }
    }, [dataDelete])

    useEffect(() => {
        if (dataUpdate) {
            console.log(dataUpdate, "dataUpdate");
            toast({
                variant: "success",
                title: "success.backendOperation.update",
                duration: 5000,
                description: "La fiche de paie " + dataUpdate?.updatePayslip?.month + "/" + dataUpdate?.updatePayslip?.year + " a été mise à jour"
            });
            refetchFromScratch(1);
        } else if (dataUpdate?.updatePayslip == false && errorUpdate) {
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 8000,
                description: errorUpdate?.message
            });
        }
    }, [dataUpdate]);

    return (
        <div className={`bg-white  w-full shadow-md px-paddingLeftAndRight py-paddingTopAndBottom rounded-sm justify-start  inline-flex gap-secondDegree ${verticalView ? "flex-col items-start" : " items-center"}`}>
            <ReadingStatus isBonus={data?.bonus} />
            {(!minimized && !verticalView && (differenceInDays < 40)) && <ReadingStatus isNew={differenceInDays < 30} />}

            <div className={minimized ? "flex items-start flex-col justify-center gap-firstDegree grow shrink-0" : "flex flex-col lg:flex-row  grow gap-firstDegree  shrink-0"}>
                <Label fontWeight={differenceInDays < 30 && "bold"} id="1">{minimized ?  `${getMonthName(month)} ${year}` :`${t("consultants.payslip.salary")} ${getMonthName(month)} ${year}`}</Label>

                {/* Profil consultant */}
                
                {shouldDisplayPayslipProfile && (
                    <div className="flex items-center gap-firstDegree shrink-0">
                        <Label fontWeight="semibold" message="consultants.informations.profile" />
                        <Label>{currentProfileName}</Label>
                    </div>
                )}

                {!minimized && <div className="grow"></div>}
                <Label fontWeight="" id="2">{data?.comment}</Label>
            </div>
            {(dataOwner || showAllInformations) ? (
                <div className={` flex gap-firstDegree min-w-[200px] flex-col 2xl:flex-row flex-wrap ${minimized ? "flex-col" : "flex-row"} ${verticalView ? "justify-start flex-col" : "justify-end"}`}>
                    {/* {console.log("this", this, "parent", parent)} */}
                    <div className="flex gap-firstDegree shrink-0">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.employeeCharges" />
                        <Label>{data?.employeeContributions} {symbol}</Label>
                    </div>
                    <div className="flex gap-firstDegree shrink-0">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.employerCharges" />
                        <Label>{data?.employerContributions} {symbol}</Label>
                    </div>
                    <div className="flex gap-firstDegree shrink-0">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.grossSalary" />
                        <Label>{data?.grossSalary} {symbol}</Label>
                    </div>

                    <div className="flex gap-firstDegree shrink-0">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.taxsOnSalary" />
                        <Label>{data?.taxes} {symbol}</Label>
                    </div>
                    <div className="flex gap-firstDegree shrink-0">
                        <Label fontWeight="semibold" message="consultants.payslip.paymentDate" />
                        <Label>{data?.paymentDate ? new Date(data?.paymentDate).toLocaleDateString() : "--"}</Label>
                    </div>
                    {showAllInformations && (
                        <>
                            <div className="flex gap-firstDegree shrink-0">
                                <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.netAmount" />
                                <Label>{data?.netSalary} {symbol}</Label>
                            </div>
                            {/* <div className="flex gap-firstDegree shrink-0">
                                <Label fontWeight="semibold" message="consultants.payslip.paymentDate" />
                                <Label>{data?.paymentDate ? new Date(data?.paymentDate).toLocaleDateString() : "--"}</Label>
                            </div> */}

                        </>
                    )}
                </div>
            ) : (
                <div className={` overflow-hidden flex gap-firstDegree flex-col xl:flex-row flex-wrap ${minimized && "flex-col"} ${verticalView ? "justify-start flex-col" : "justify-end"}`}>
                    <div className="flex gap-firstDegree">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.grossSalary" />
                        <Label>{data?.grossSalary} {symbol}</Label>
                    </div>
                    <div className="flex gap-firstDegree">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.netAmount" />
                        <Label>{data?.netSalary} {symbol}</Label>
                    </div>
                    <div className="flex gap-firstDegree">
                        <Label fontWeight={differenceInDays < 30 ? "bold" : "semibold"} message="consultants.payslip.taxsOnSalary" />
                        <Label>{data?.taxes} {symbol}</Label>
                    </div>
                    <div className="flex gap-firstDegree">
                        <Label fontWeight="semibold" message="consultants.payslip.paymentDate" />
                        <Label>{data?.paymentDate ? new Date(data?.paymentDate).toLocaleDateString() : "--"}</Label>
                    </div>
                </div>
            )}

            {(loadingDelete || loadingFile) && <span className="loader" />}
            <div className={`flex gap-firstDegree shrink-0  ${verticalView ? "w-full justify-center" : ""}`}>
                <ControlsDownload
                    dataOwner={dataOwner}
                    onClickNewTab={handleOpenPayslipFile}
                    onClickDownload={() => console.log("onClickDownload")}
                    onClickDelete={handleDelete}
                    hideOpenNewTab={hideControls || (!data?.payslipFileUuid && minimized)}
                    disabledOpenNewTab={!data?.payslipFileUuid || errorFile}
                    disabledDelete={errorDelete}
                    hideEdit={hideControls || !editable || !hasPrivileges('ADMIN_PAYSLIP')}
                    hideDelete={hideControls || (minimized && !removePayslip)}
                    onClickEdit={() => setIsEditModalOpen(true)}
                    hideDownload
                    titleForDelete={t("consultants.payslip.salary") + " : " + (getMonthName(month)) + " - " + year}
                />
            </div>

            {isEditModalOpen && (
                <EditAdminModal
                    data={data}
                    onClose={() => setIsEditModalOpen(false)}
                    type="payslip"
                    form={
                        <FormNewPayslip global data={data} forEdition forMassiveInput={forMassiveInput} onSubmit={handleSubmitUpdate} submitRef={submitRef} submissionSuccess={submissionSuccess} submissionError={submissionError} />
                    }
                    onSubmitForm={() => submitRef.current && submitRef.current.click()}
                />
            )}
        </div>
    );
}
